<template id="table-template">
  <div class="w-full">
    <table class="w-full" ref="baseTable">
      <thead>
        <tr>
          <th v-if="selectable" class="px-4">
            <input type="checkbox" :checked="isSelectAll" :indeterminate.prop="isIndeterminate" @click="selectAll()" />
          </th>
          <th scope="col" v-for="header in headers" :key="header.value" class="sm:w-1/4" @click="order(header.value)" :class="{ 'active': isOrderActive(header.value) }">
            <span class="cursor-pointer hover:text-green-dark mr-1">
              {{ header.label }}
            </span>
            <font-awesome-icon v-show="isOrderActive(header.value)" :icon="showArrow" size="lg" :transform="arrowTransform" />
          </th>
          <th class="sm:w-1/4 text-right"></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="row in body" :key="row.id" class="border-b border-grey-lighter cursor-pointer hover:bg-grey-lightest">
          <td v-if="selectable" class="px-4">
            <input type="checkbox" v-model="selected" :value="row.id" @change="select" />
          </td>
          <td v-for="(column, index) in headers" :key="column.value" :data-label="column.label" @click.self="clicked(row)" :class="{ 'whitespace-no-wrap pr-4': index === 0 }">
            {{ row[column.value] }}
          </td>
          <td class="py-4 text-right actions whitespace-no-wrap" v-if="actions">
            <router-link v-if="actions.editable" @click.stop :to="{ name: type, params: { id: row.id } }">
              wijzig
            </router-link>
            <a role="button" v-if="actions.removable" @click.prevent="remove(row)">
              verwijder
            </a>
          </td>
          <td class="py-4 text-right actions" v-else>
            <span class="italic">readonly</span>
          </td>
        </tr>
      </tbody>
    </table>
    <base-notification
      :type="notification.type"
      :message.sync="notification.message"
    ></base-notification>
  </div>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import BaseNotification from '@/components/globals/BaseNotification';

export default {
  template: '#table-template',
  components: {
    FontAwesomeIcon,
    BaseNotification
  },
  props: {
    headers: {
      type: Array,
      default: function() {
        return [
          { label: 'Naam', value: 'name', order: true },
          { label: 'Gemaakt op', value: 'created_at', order: true },
          { label: 'Gewijzigd op', value: 'updated_at', order: true }
        ];
      }
    },
    body: {
      type: Array
    },
    sortKey: {
      type: String,
      default: 'created_at'
    },
    reversed: {
      type: Boolean,
      default: true
    },
    actions: {
      type: Object,
      default: null
    },
    type: {
      type: String
    },
    selectable: {
      type: Boolean,
      required: false
    }
  },
  data() {
    return {
      key: '',
      reverse: false,
      selected: [],
      notification: {
        type: 'info',
        message: ''
      }
    };
  },
  created() {
    this.key = this.sortKey;
    this.reverse = this.reversed;
  },
  methods: {
    select(event) {
      event.target.parentNode.parentNode.classList.toggle('selected');
      this.$emit('selected', this.selected);
    },
    selectAll() {
      const rows = this.$refs.baseTable.tBodies[0].rows;
      const length = rows.length;

      if (this.isIndeterminate || this.isSelectAll) {
        for (let i = 0; i < length; i++) {
          rows[i].classList.remove('selected');
        }
        this.selected = [];
      } else {
        for (let i = 0; i < length; i++) {
          rows[i].classList.add('selected');
        }
        this.selected = this.body.map(row => row.id);
      }
      this.$emit('selected', this.selected);
    },
    order(name) {
      this.key = name;
      this.reverse = this.key == name ? !this.reverse : false;
      this.$emit('ordered', name);
    },
    isOrderActive(name) {
      return this.key.replace('-', '') == name;
    },
    openModal(item, type) {
      this.$emit('modal', { item: item, type: type });
    },
    clicked(data) {
      let params = { id: data.id };

      if (data.name) {
        params['label'] = data.name;
      }

      this.$emit('clicked', params);
    },
    async remove(complex) {
      const answer = window.confirm('Weet u zeker dat u dit wilt verwijderen?');

      if (!answer) return;
      try {
        await this.$store.dispatch(`${this.type}/remove`, complex);
        this.notification.type = 'success';
        this.notification.message = 'Succesvol verwijderd.';
      } catch (err) {
        this.notification.type = 'error';
        if (!err.title) {
          return (this.notification.message =
            'Er is iets fout gegaan, probeer het later opnieuw.');
        }
        this.notification.message = err.title;
      }
    }
  },
  computed: {
    isIndeterminate() {
      return this.selected.length > 0 && !this.isSelectAll;
    },
    isSelectAll() {
      return this.body.length > 0 && this.selected.length === this.body.length;
    },
    showArrow() {
      return this.reverse ? ['fas', 'sort-down'] : ['fas', 'sort-up'];
    },
    arrowTransform() {
      return this.reverse ? 'up-3' : 'down-3';
    }
  }
};
</script>

<style>
table tr.selected,
table tr.selected:hover {
  @apply bg-blue-lighter;
  @apply text-white;
}
table tr.selected td.actions a {
  @apply text-grey-dark;
}
</style>
